(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@fiverr/globals"), require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["@fiverr/globals", "react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["SellerCard"] = factory(require("@fiverr/globals"), require("react"), require("react-dom"));
	else
		root["SellerCard"] = factory(root["@fiverr/globals"], root["React"], root["ReactDOM"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_E4I8__, __WEBPACK_EXTERNAL_MODULE_Jmof__, __WEBPACK_EXTERNAL_MODULE_wLXD__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition